import { render } from "./MattersArisingComments.vue?vue&type=template&id=690bfbc8"
import script from "./MattersArisingComments.vue?vue&type=script&lang=js"
export * from "./MattersArisingComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__